import React from "react";

/**
 * WorkMesh logo — custom SVG mark.
 * A hexagonal mesh node with 3 connecting links, evoking a network of collaborators.
 * Paired with an optional wordmark.
 */
export function WorkMeshMark({ size = 28, className = "", accent = "currentColor" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="WorkMesh"
    >
      {/* mesh triangles - central node with 3 satellites */}
      <path
        d="M16 4 L28 11 L28 21 L16 28 L4 21 L4 11 Z"
        stroke={accent}
        strokeWidth="1.6"
        fill="none"
        strokeLinejoin="round"
      />
      {/* inner links */}
      <line x1="16" y1="4" x2="16" y2="28" stroke={accent} strokeWidth="1.2" opacity="0.55" />
      <line x1="4" y1="11" x2="28" y2="21" stroke={accent} strokeWidth="1.2" opacity="0.55" />
      <line x1="28" y1="11" x2="4" y2="21" stroke={accent} strokeWidth="1.2" opacity="0.55" />
      {/* nodes */}
      <circle cx="16" cy="4" r="2.2" fill={accent} />
      <circle cx="28" cy="11" r="2.2" fill={accent} />
      <circle cx="28" cy="21" r="2.2" fill={accent} />
      <circle cx="16" cy="28" r="2.2" fill={accent} />
      <circle cx="4" cy="21" r="2.2" fill={accent} />
      <circle cx="4" cy="11" r="2.2" fill={accent} />
      {/* central hot node */}
      <circle cx="16" cy="16" r="3.4" fill="#E1252A" />
    </svg>
  );
}

export function WorkMeshLogo({ size = 28, showWordmark = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <WorkMeshMark size={size} />
      {showWordmark && (
        <span className="font-bold text-lg tracking-tight" style={{ fontFamily: "'Cabinet Grotesk', 'Satoshi', sans-serif" }}>
          Work<span className="text-[#E1252A]">Mesh</span>
        </span>
      )}
    </div>
  );
}
